var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            "append-to-body": "",
          },
          on: {
            open: _vm.open,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { model: _vm.ruleForm, rules: _vm.rules } },
            [
              _c(
                "v-form-item",
                { attrs: { prop: "productKey" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("产品")]),
                  ]),
                  _c("v-select", {
                    attrs: {
                      id: "productKey",
                      name: "productKey",
                      placeholder:
                        _vm.productKeyOptins.length > 0
                          ? "请选择"
                          : "请先新建产品",
                      options: _vm.productKeyOptins,
                    },
                    model: {
                      value: _vm.productKey,
                      callback: function ($$v) {
                        _vm.productKey = $$v
                      },
                      expression: "productKey",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "topic" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("topic")]),
                  ]),
                  _c("v-input", {
                    attrs: { type: "text", name: "topic" },
                    model: {
                      value: _vm.ruleForm.topic,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "topic", $$v)
                      },
                      expression: "ruleForm.topic",
                    },
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }